module.exports = __webpack_public_path__ + "static/media/img_mausoleo.b726807a.jpg";